import { documentationActions } from '../../actions/constant';

const {
  UNDO_DOCUMENT_SIGN_SUCCESS,
  UNDO_DOCUMENT_SIGN_REQUEST,
  UNDO_DOCUMENT_SIGN_FAILURE,
  UNDO_DOCUMENT_SIGN_RESET,
} = documentationActions;

const initialstate: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const undoDocumentSignReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case UNDO_DOCUMENT_SIGN_SUCCESS: {
      return {
        ...state,
        response: action.payload?.data,
        loading: false,
        isSuccess: true,
      };
      true;
    }

    case UNDO_DOCUMENT_SIGN_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case UNDO_DOCUMENT_SIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UNDO_DOCUMENT_SIGN_RESET:
      return initialstate;

    default:
      return state;
  }
};
